import { CollectionReturnValue, Core } from 'cytoscape';

export interface Position {
  x: number;
  y: number;
}
export interface FlowMouseEvent {
  type: 'mouseUp' | 'mouseDown';
  position: Position;
  originalEvent: MouseEvent;
}

export interface CancelTargetSelectionEvent {
  source: string;
  position: Position;
  originalEvent: MouseEvent;
}

export interface TargetSelectionEvent {
  source: string;
  target?: string;
  originalEvent: MouseEvent;
}

export interface StartTargetSelectionEvent {
  source: string;
  originalEvent: MouseEvent;
}

export interface CyElement {
  isRegistered: boolean;
  registerCy(cy: Core): void;
  getCyElement(): CollectionReturnValue;
}
